import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography,
} from "@material-ui/core";

const STORAGE_KEY = "kimat_legal_acknowledged_v1";

export default function LegalAcknowledgementDialog() {
    const [open, setOpen] = useState(false);
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        const value = localStorage.getItem(STORAGE_KEY);
        if (value !== "true") {
            setOpen(true);
        }
    }, []);

    const handleConfirm = () => {
        localStorage.setItem(STORAGE_KEY, "true");
        setOpen(false);
    };

    return (
        <Dialog open={open} disableEscapeKeyDown maxWidth="sm" fullWidth>
            <DialogTitle>Wichtiger Hinweis</DialogTitle>

            <DialogContent dividers>
                <Typography paragraph>
                    kimat-online bietet keine Anlageberatung, keine Anlagevermittlung
                    und keine Vermögensverwaltung an.
                </Typography>

                <Typography paragraph>
                    Die angezeigten Inhalte, Signale und KI-Auswertungen dienen
                    ausschließlich Informationszwecken und können fehlerhaft,
                    unvollständig oder verspätet sein.
                </Typography>

                <Typography paragraph>
                    Investitionsentscheidungen treffen Sie ausschließlich in eigener
                    Verantwortung.
                </Typography>

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Ich habe verstanden, dass es sich nicht um Anlageberatung handelt."
                />
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleConfirm}
                    color="primary"
                    variant="contained"
                    disabled={!accepted}
                >
                    Bestätigen
                </Button>
            </DialogActions>
        </Dialog>
    );
}